import { http } from '../http'
import { mockCreateMusicGeneration, mockGetMusicGenerationStatus } from '@/mocks/musicMock'
import type {
	CreateMusicGenerationData,
	MusicGenerationResponse,
	CreateSongGenerationData,
	SongGenerationResponse,
	MusicStatusResponse
} from '@/types'

export async function createMusicGeneration(data: CreateMusicGenerationData): Promise<MusicGenerationResponse> {
	if (import.meta.env.VITE_MUSIC_MOCK) {
		return mockCreateMusicGeneration()
	}
	const response = await http.post('/thread-music', data)
	return response.data
}

export async function createSongGeneration(data: CreateSongGenerationData): Promise<SongGenerationResponse> {
	const response = await http.post('/thread-song', data)
	return response.data
}

export async function getMusicGenerationStatus(taskId: string): Promise<MusicStatusResponse> {
	if (import.meta.env.VITE_MUSIC_MOCK) {
		return mockGetMusicGenerationStatus(taskId)
	}
	// без общего beginRequest() — статус-опросы разных тредов не должны затирать AbortController
	const response = await http.get('/thread-music-status', {
		params: { task_id: taskId }
	})
	return response.data
}
